import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { API_URL } from "..";
const optionsForServices = [
  {
    label: "Electrical Installation Condition Report",
    value: "Electrical Installation Condition Report",
  },
  {
    label: "Rwiring House",
    value: "Rwiring House",
  },
  {
    label: "PAT Testing",
    value: "PAT Testing",
  },
  {
    label: "Electrical Fuse Box Installation",
    value: "Electrical Fuse Box Installation",
  },
  {
    label: "Electrical Fault",
    value: "Electrical Fault",
  },
  {
    label: "Electrical Sockets & Switches Installation",
    value: "Electrical Sockets & Switches Installation",
  },
  {
    label: "Electrical Light Fitting",
    value: "Electrical Light Fitting",
  },
  {
    label: "Electrical Outdoor Light Installation",
    value: "Electrical Outdoor Light Installation",
  },
  {
    label: "Electrical Car Charger",
    value: "Electrical Car Charger",
  },
  {
    label: "Electrical Inspection",
    value: "Electrical Inspection",
  },
];

const AddAppointmentLayer = () => {
  const [electricianList, setElectricianList] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [electricianListSelect, setElectricianListSelect] = useState({});

  const fetchElectrician = async () => {
    let headerList = {
      Accept: "*/*",
      "Content-type": "application/json",
    };
    const response = await fetch(
     API_URL+"/api/user/fetch-electrician",
      { method: "GET", headers: headerList }
    );
    const data = await response.json();
    if (response.status === 200) {
      let mapedData = data.data.map((e) => ({
        label: e.name,
        value: e.id,
      }));
      setElectricianList(mapedData);
    }
  };
  useEffect(() => {
    fetchElectrician();
  }, [1]);
  const onFormSubmission = async (event) => {
    event.preventDefault();
    const user = JSON.parse(localStorage.getItem('user'));
    let headerList = {
      Accept: "*/*",
      "Content-type": "application/json",
    };
    const bodyContent = JSON.stringify({
      "client_name": event.target.elements.client_name.value,
      "email": event.target.elements.email.value,
      "phone": event.target.elements.phone.value,
      "address": event.target.elements.address.value,
      "job_cost": event.target.elements.job_cost.value,
      "postcode": event.target.elements.postcode.value,
      "service_required":selectedServices.toString(),
      "assigned_to" :electricianListSelect?.value,
      "assigned_by": user.id,
     "description" : event.target.elements.description.value

    });
    const response = await fetch(API_URL+'/api/job/create',{method:'POST', headers:headerList, body: bodyContent});
    const data = await response.json();
    if(response.status === 201){
        console.log(data.job)
    }else{
        alert('Invalid Information')
    }
  };
  const handleChangeElectrician = (selected) => {
    setElectricianListSelect(selected || {});
  };
  const handleChangeService = (selectedOptions) => {
    // Set the state to an array of selected values
    setSelectedServices(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-8 col-lg-10">
            <div className="card border">
              <div className="card-body">
                {/* Upload Image End */}
                <form onSubmit={onFormSubmission}>
                  <div className="mb-20">
                    <label
                      htmlFor="name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Client Name <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="name"
                      name="client_name"
                      placeholder="Enter Full Name"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="email"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Email <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control radius-8"
                      id="email"
                      name="email"
                      placeholder="Enter email address"
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      className="form-control radius-8"
                      id="number"
                      name="phone"
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Job Cost
                    </label>
                    <input
                      type="number"
                      min={0}
                      className="form-control radius-8"
                      id="number"
                      name="job_cost"
                      placeholder="0.00"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="number"
                      name="address"
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      PostCode
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="number"
                      name="postcode"
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="service"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Select Service that required
                    </label>
                    <Select
                      id="service"
                      options={optionsForServices}
                      isMulti
                      onChange={handleChangeService}
                    />
                  </div>
                  <div className="mb-20">
                    <p>

                      {selectedServices.map((e,index) => {
                        return <span key={index}>{e+','}</span>;
                      })}
                    </p>
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="select"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Select Service Electrician
                    </label>
                    <Select
                      id="select"
                      options={electricianList}
                      onChange={handleChangeElectrician}
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="desc"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Description
                    </label>
                    <textarea
                      name="description"
                      className="form-control radius-8"
                      id="desc"
                    
                      placeholder="Write description..."
                      defaultValue={""}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAppointmentLayer;
